<template>
  <div id="modalLogisticsLog" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{
              type == 1 || log_info
                ? $t("distributor.物流轨迹")
                : $t("distributor.操作日志")
            }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25" v-if="log_info">
          <table class="table mg-b-20">
            <tbody class="result-info track-info">
              <tr v-if="log_info.companyName">
                <td class="row1 valign-middle">
                  <span class="day">{{ $t("distributor.物流公司：") }}</span>
                </td>
                <td class="context valign-middle">
                  {{ log_info.companyName }}
                </td>
              </tr>
              <tr v-if="log_info.expressCode">
                <td class="row1 valign-middle">
                  <span class="day">{{ $t("distributor.物流单号：") }}</span>
                </td>
                <td class="context valign-middle">
                  {{ log_info.expressCode }}
                  <a
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="log_info.expressCode"
                  >
                    <i class="icon ion-clipboard tx-gray-900"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table mg-b-0">
            <tbody
              v-if="log_info && log_info.trackInfo.length > 1"
              class="result-info"
            >
              <tr
                v-for="(item, index) in log_info.trackInfo"
                :key="index"
                :class="[
                  index == 0 ? 'first' : '',
                  index == log_info.trackInfo.length - 1 ? 'last' : '',
                ]"
              >
                <td class="row1 valign-middle">
                  <span class="day">{{ item.time }}</span>
                </td>
                <td class="status status-wait valign-middle">
                  <div class="col2">
                    <i class="fa fa-angle-up" v-if="index != 0"></i>
                    <i
                      class="fa"
                      v-if="index == 0"
                      :class="[
                        log_info.status == 3 || log_info.status == 4
                          ? 'fa-check'
                          : 'undone',
                      ]"
                    ></i>
                  </div>
                </td>
                <td class="context valign-middle">
                  {{ item.station }}
                </td>
              </tr>
            </tbody>
            <tbody
              v-if="log_info && log_info.trackInfo.length == 1"
              class="result-info"
            >
              <tr
                v-for="(item, index) in log_info.trackInfo"
                :key="index"
                class="only"
              >
                <td class="row1 valign-middle">
                  <span class="day">{{ item.time }}</span>
                </td>
                <td class="status status-wait valign-middle">
                  <div class="col2">
                    <i
                      class="fa"
                      :class="[
                        log_info.status == 3 || log_info.status == 4
                          ? 'fa-check'
                          : 'undone',
                      ]"
                    ></i>
                  </div>
                </td>
                <td class="context valign-middle">
                  {{ item.station }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-body pd-25" v-else>
          <table class="table mg-b-20" v-if="type == 1">
            <tbody class="result-info track-info">
              <tr v-if="info.companyName">
                <td class="row1 valign-middle">
                  <span class="day">{{ $t("distributor.物流公司：") }}</span>
                </td>
                <td class="context valign-middle">
                  {{ info.companyName }}
                </td>
              </tr>
              <tr v-if="info.trackNumber">
                <td class="row1 valign-middle">
                  <span class="day">{{ $t("distributor.物流单号：") }}</span>
                </td>
                <td class="context valign-middle">
                  {{ info.trackNumber }}
                  <a
                    class="to-clipboard"
                    href="javascript:;"
                    :data-clipboard-text="info.trackNumber"
                  >
                    <i class="icon ion-clipboard tx-gray-900"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table mg-b-0">
            <tbody
              v-if="type == 1 && info && info.trackInfo.length > 1"
              class="result-info"
            >
              <tr
                v-for="(item, index) in info.trackInfo"
                :key="index"
                :class="[
                  index == 0 ? 'first' : '',
                  index == info.trackInfo.length - 1 ? 'last' : '',
                ]"
              >
                <td class="row1 valign-middle">
                  <span class="day">{{ item.time }}</span>
                </td>
                <td class="status status-wait valign-middle">
                  <div class="col2">
                    <i class="fa fa-angle-up" v-if="index != 0"></i>
                    <i
                      class="fa"
                      v-if="index == 0"
                      :class="[
                        info.status == 3 || info.status == 4
                          ? 'fa-check'
                          : 'undone',
                      ]"
                    ></i>
                  </div>
                </td>
                <td class="context valign-middle">
                  {{ item.station }}
                </td>
              </tr>
            </tbody>
            <tbody
              v-if="type == 1 && info && info.trackInfo.length == 1"
              class="result-info"
            >
              <tr
                v-for="(item, index) in info.trackInfo"
                :key="index"
                class="only"
              >
                <td class="row1 valign-middle">
                  <span class="day">{{ item.time }}</span>
                </td>
                <td class="status status-wait valign-middle">
                  <div class="col2">
                    <i
                      class="fa"
                      :class="[
                        info.status == 3 || info.status == 4
                          ? 'fa-check'
                          : 'undone',
                      ]"
                    ></i>
                  </div>
                </td>
                <td class="context valign-middle">
                  {{ item.station }}
                </td>
              </tr>
            </tbody>
            <tbody v-if="type == 2">
              <tr v-for="(item, index) in info.remark" :key="index">
                <td class="valign-middle hidden-xs-down">
                  <div>{{ item }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("distributor.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "info", "type", "log_info"],
  data() {
    return {
      track: [{ time: 2018, station: "999" }],
    };
  },
  created() {},
  updated() {},
  watch: {
    open: function () {},
  },
  methods: {},
};
</script>
<style scoped="scoped">
.result-info .row1 {
  width: 105px;
  text-align: center;
  padding-left: 14px;
  padding-right: 0;
}
.result-info .status {
  position: relative;
  width: 30px;
}
.result-info td {
  border: none !important;
  padding-top: 10px;
  padding-bottom: 10px;
}
.track-info td {
  border: none !important;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #343a40;
}
.status .col2 {
  position: relative;
  z-index: 1;
  width: 18px;
  height: 18px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 100%;
  background: #fff;
  margin: 0 auto;
}
.status .col2 i {
  color: #ccc;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.status:before {
  content: "";
  width: 0;
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  z-index: 0;
  border-left: 1px solid #ddd;
}
.first .status:before {
  top: 50%;
}
.first .status:before,
.last .status:before {
  height: 50%;
}
.only .status:before {
  display: none;
}
.only td,
.first td {
  color: #23bf08;
}
.only .status .col2,
.first .status .col2 {
  border: 1px solid #23bf08;
}
.only .status .col2 i,
.first .status .col2 i {
  color: #23bf08;
}
.col2 i.undone {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: #23bf08;
}
.col2 i.fa-check {
  font-size: 12px !important;
}
</style>
